import * as React from 'react';
import {useTheme} from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {Chip, Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {BarChart, PieChart, PieValueType} from '@mui/x-charts';
import {OptionType} from "@/model/global";
import {XYVO} from "@/service/analyze";
import {useMemo} from "react";
import {find, isEmpty, sum} from 'lodash';
import {BarSeriesType} from "@mui/x-charts/models/seriesType/bar";

export interface SellerProductRankingProps {
    option: OptionType
    top10ProjectClas: XYVO[]
    top10PatentClas: XYVO[]
    top10TrademarkClas: XYVO[]
    top10CopyrightClas: XYVO[]
    loading: boolean
}

export default function SellerProductRanking({loading, option, top10ProjectClas, top10TrademarkClas, top10CopyrightClas, top10PatentClas}: SellerProductRankingProps) {

    const splitStr = (xy: XYVO) => {
        const z: string = xy.z;
        const zs: string[] = z.split(",");
        return zs.map((item: string) => {
            const arr = item.split("=");
            return {name: arr[0] || "", value: parseInt(arr[1]) || 0};
        });
    }

    const {bSeries, pData, top10ProductClas} = useMemo(() => {
            let top10ProductClas: XYVO[] = []
            switch (option.value) {
                case 1:
                    top10ProductClas = top10ProjectClas
                    break
                case 2:
                    top10ProductClas = top10PatentClas
                    break
                case 3:
                    top10ProductClas = top10TrademarkClas
                    break
                case 4:
                    top10ProductClas = top10CopyrightClas
                    break
            }
            if (!isEmpty(top10ProductClas)) {
                const categories: string[] = splitStr(top10ProductClas[0])?.map(item => item.name)
                const bSeries: BarSeriesType[] = categories.map((category: string) => {
                    const data: number[] = top10ProductClas?.map(top10Project => {
                        const values = splitStr(top10Project)
                        const findProject = find(values, item => item.name === category);
                        return (findProject?.value || 0)
                    })
                    return ({
                        data: data, stack:
                            'B', label:
                        category, type: 'bar'
                    })
                })
                const pData: PieValueType[] = bSeries.map((item: BarSeriesType, index: number) => {
                    const value = sum(item.data)
                    return ({
                        label: item.label as string,
                        value: value,
                        id: index
                    })
                })
                return {pData, bSeries, top10ProductClas}
            }
            return {pData: [], bSeries: [], top10ProductClas: []}
        },
        [top10ProjectClas, top10TrademarkClas, top10CopyrightClas, top10PatentClas, option]
    )

    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack direction={'row'} spacing={2} mb={1} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        业务人员{option?.label}排名
                    </Typography>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        {option.label}数量分布
                    </Typography>
                </Stack>
                <Grid container justifyContent={'space-between'} spacing={3}>
                    <Grid size={7}>
                        <BarChart
                            layout={'horizontal'}
                            hideLegend={true}
                            loading={loading}
                            localeText={{loading: "加载中", noData: "暂无数据"}}
                            margin={{left: 0, right: 0, top: 10, bottom: 0}}
                            series={bSeries || []}
                            height={180}
                            yAxis={[{data: top10ProductClas?.map(item => item.x), categoryGapRatio: 0.4, barGapRatio: 0.8, disableLine: true, disableTicks: true}]}
                            xAxis={[{disableLine: true, disableTicks: true, position: 'bottom'}]}
                        />
                    </Grid>
                    <Grid size={5}>
                        <PieChart
                            margin={{left: 0, right: 0, top: 10, bottom: 0}}
                            loading={loading}
                            localeText={{loading: "加载中", noData: "暂无数据"}}
                            series={[
                                {
                                    innerRadius: 54,
                                    outerRadius: 70,
                                    paddingAngle: 6,
                                    id: 'productAmount',
                                    data: pData || [],
                                },
                            ]}
                            width={160}
                            height={160}
                            hideLegend
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
